module.exports = __webpack_public_path__ + "static/media/video.82917f5a.svg";